module.exports = __webpack_public_path__ + "img/2ue-954.b3ee7f47.png";